import Head from 'next/head'
import { useContext, useEffect, useMemo } from 'react'
import {
    buildStorefrontCssDeclarations,
    buildStorefrontCssVariables,
    PRIMARY_FONT_CSS_VAR,
} from '@storefronts/common-types'
import { CustomizationContext } from '../context/customizationContext'

export const CSSVariableSetter: React.FC = () => {
    const customizationContext = useContext(CustomizationContext)
    const entries = useMemo(
        () => buildStorefrontCssVariables(customizationContext, true),
        [customizationContext],
    )

    // Backup in case landingpage settings change after load.
    // CSS variables will be set server side
    useEffect(() => {
        for (const [name, value] of entries) {
            document.documentElement.style.setProperty(name, value)
        }
        // Set on body directly (not documentElement) because the admin frontend iframe
        // has body-level font overrides (globals.css, Chakra UI) that ignore CSS variables on :root
        document.body.style.setProperty(
            'font-family',
            `var(${PRIMARY_FONT_CSS_VAR})`,
        )

        return () => {
            document.body.style.removeProperty('font-family')
            for (const [name] of entries) {
                document.documentElement.style.removeProperty(name)
            }
        }
    }, [entries])

    return (
        <Head>
            <style
                key="custom-font-variables"
                dangerouslySetInnerHTML={{
                    __html: buildStorefrontCssDeclarations(
                        customizationContext,
                        true,
                    ),
                }}
            />
        </Head>
    )
}
